import React, { useMemo, useReducer } from 'react';
import { observer } from 'mobx-react';
import type { ReactElement } from 'react';

import { DesignLayout } from '@common/DesignLayout';
import { menuConfig } from '@components/AppRouter/menuConfig';
import { usePermission } from '@src/utils/hooks/usePermission';
import { userStore } from '@stores/userStore';

import { filterRoutes } from '../AppRouter/routeConfig/utils';
import { DesignAlert } from './DesignAlert';
import { useAlert } from './DesignAlert/hooks';
import { Group } from './Group';
import { Search } from './Search';

import styles from './HomePage.module.scss';

const HomePageComp = (): ReactElement => {
  const { user, extraView } = userStore;
  const { shown, setAddCount } = useAlert();
  const [showShadow, toggle] = useReducer((state) => !state, true);

  const permSearchMenu = usePermission('CmSearchMenu');

  const filteredRoutes = useMemo(() => filterRoutes({ routes: menuConfig, user }), [user]);

  return (
    <DesignLayout scrollEnable className={styles.homePage}>
      <div className={styles.wrapper}>
        <div className={styles.banner}>
          <div className={styles.bannerSignatureWrapper}>
            <div
              className={styles.bannerSignature}
              dangerouslySetInnerHTML={{ __html: `Информационная система <br /> &quot;Расчетный модуль&quot;` }}
            />
          </div>
          <div className={styles.bannerImageWrapper}>
            <button className={styles.bannerImage} onClick={() => setAddCount()} />
          </div>
        </div>

        {permSearchMenu.VIEW && <Search config={filteredRoutes} />}

        <div className={styles.routes}>
          {filteredRoutes.map((route) => (
            <Group key={`${route.title} ?? ${route.path}`} route={route} shadow={showShadow} toggle={toggle} />
          ))}
        </div>

        <DesignAlert show={extraView && shown} toggleShow={setAddCount} />
      </div>
    </DesignLayout>
  );
};

export const HomePage = observer(HomePageComp);
